/* 🤖 this file was generated by script */
export const wiconUploadCloud01 = {
  name: 'upload_cloud_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16.24a4.5 4.5 0 012.08-8.22 6 6 0 0111.84 0A4.5 4.5 0 0120 16.24M8 16l4-4m0 0l4 4m-4-4v9"/></svg>`,
};
